import type { Observable } from 'rxjs';
import type { AdminGroupsPage } from './admin-groups.page';

/**
 * Blocks navigation away from the Groups page while a form modal holds unsaved
 * work, so browser Back (or sidebar nav) can't silently discard it. Delegates
 * the decision to the page component, which prompts the user to confirm.
 */
export const adminGroupsCanDeactivateGuard = (
  component: AdminGroupsPage,
): Observable<boolean> => component.canDeactivate();
